<!-- SELECT2 COM OPÇÕES ESTATICAS E SELECAO DE MULTIPLAS OPÇÕES
https://select2.org/

          <select2static v-model="campoteste"
              :options="[{id: 'C', text: 'Cliente'},{id: 'F', text: 'Fornecedor'},{id: 'T', text: 'Transportadora'}]"
              :value="campoteste"
              :multiple="true"
              :minlength="0">
          </select2static>
-->

<template>
  <div class="w-100">
    <select class="form-control" :tabindex="tabindex" :disabled="disabled" :multiple="multiple">
      <slot></slot>
    </select>
  </div>
</template>

<script>
import { SysVars } from '../main';
import { hasHiddenParent } from '../shared/utils';

export default {

    props: {
      options: {required: false},
      value: {required: false},
      entity: {type: String, default: '', required: false},
      url: {type: String, default: '', required: false},
      minlength: {type: Number, default: '', required: true},
      parent: {type: String, required: false},
      disabled: {type: Boolean, default: false, required: false},
      focus: {type: Boolean, default: false},
      tabindex: {type: Number},
      multiple: {type: Boolean, default: false},
      placeholder: {type: String},
    },

    data () {
      return {
        onChangeEvent: false,
        onWatchEvent: false,
      }
    },

    mounted () {
      this.initSelect2()
      this.$nextTick(function () {
        this.initValueSelect2()
      });

    },

    watch: {
      value: function (value) {
        if (this.onChangeEvent) {
          return
        }
        this.onWatchEvent = true
        jQuery(this.$el).find('select').val(value?value:'').trigger('change')
        this.onWatchEvent = false
      },

      focus: function (value) {
        if (value) this.$el.querySelector('select').focus()
      },

      options: function (value) {
        var obj = {
            minimumInputLength: 0,
            placeholder: "",
            allowClear: true,
            theme: "bootstrap",
            data: this.options,
            closeOnSelect: !this.multiple,
        }

        if (this.placeholder) {
          obj.placeholder = {
            id: '-1',
            text: this.placeholder
          }
        }

        let parent = window.jQuery(this.$el).parent()
        Object.assign(obj, { dropdownParent: parent })


        if (this.parent != undefined && this.parent != '') {
          Object.assign(obj, { dropdownParent: window.jQuery('#' + this.parent) })
        }
        jQuery(this.$el).find('select').select2(obj)
      }

    },

    created () {

    },

    methods: {

      initValueSelect2 () {

        let vm = this
        if (!this.value || this.value == '' || this.value == null) {
          //limpa o select2 quando receber um valor nulo
          jQuery(vm.$el).find('select').val('').trigger('change')
          return
        }

      },


      initSelect2 () {
        //efetua a inicializacao do Select2

        var vm = this

        var obj = {
            minimumInputLength: 0,
            placeholder: "",
            allowClear: true,
            theme: "bootstrap",
            data: this.options,
            closeOnSelect: !this.multiple,
        }

        if (this.placeholder) {
          obj.placeholder = {
            id: '-1',
            text: this.placeholder
          }

        }

        let parent = window.jQuery(this.$el).parent()
        Object.assign(obj, { dropdownParent: parent })


        if (this.parent != undefined && this.parent != '') {
          Object.assign(obj, { dropdownParent: window.jQuery('#' + this.parent) })
        }

        window.jQuery(this.$el).find('select')    //https://select2.org/data-sources/ajax
          .select2(obj)
          .trigger('change')      // emit event on change.
          .on('change', function () {
            vm.onChangeEvent = true;
            if (!vm.onWatchEvent) {
              if (this.value =='')
                vm.$emit('input', null);
              else{
                if (vm.multiple) {
                  vm.value = jQuery(vm.$el).find('select').val();
                  vm.$emit('input', jQuery(vm.$el).find('select').val())
                }else{
                  vm.$emit('input', this.value);
                }

              }
              //vm.$emit('input', jQuery(vm.$el).find('select').val())
            }
            vm.onChangeEvent = false;
          }).on('keyup', function (e) {
          }).on('keypress', function (e) {
          })

        this.obj = jQuery(vm.$el).find('select')

//        window.jQuery(this.$el).find('select').val(this.value? this.value : '').trigger('change')

        jQuery(vm.$el).on('keydown', '.select2-selection', function(e) {
          if (e.which === 13) {
              e.preventDefault();
              var thisIndex = jQuery(vm.$el.querySelector('select')).index(SysVars.sFocusControl)
              var next = thisIndex + 2
              var obj = jQuery(SysVars.sFocusControl)
              for (var x = next; x < obj.length; x++) {
                if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
                  jQuery(obj[x]).focus()
                  return
                }
              }
              for (var x = 0; x < obj.length; x++) {
                if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
                  jQuery(obj[x]).focus()
                  return
                }
              }
          }
        })

      }

    },

    destroyed() {
      //console.log('select2 destroy:')
      //jQuery(this.$el).off().select2('destroy')
    }

}
</script>

<style scoped>
  select {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/select2static.vue